import { STATUSES } from '../../../data/constants';
import { Card, Badge } from '@pella/sash-framework';
import { RequestCardHistory } from './RequestCardHistory';
import { RequestCardButtons } from './RequestCardButtons';

import * as classes from './RequestCards.module.css';
import { DynamicActionInputResult } from '../../atoms/DynamicActionInputResult/DynamicActionInputResult';

const ACCEPTED_HISTORY_STATUS = new Set([STATUSES.ACCEPTED, STATUSES.COMPLETED]);

/**
 * Request Cards molecule
 * @param {Local.RequestCardsProps} props - Component props
 */
export const RequestCards = ({ data }) => (
  <div className={classes.container}>
    {data?.map((req) => (
      <Card key={req.id} data-testid='request-card' className={classes.card}>
        <div className={classes.header}>
          <div className={classes.action}>
            <div>{req.action.description}</div>
            <div>{req.action.message}</div>
          </div>
          <Badge color='neutral' variant='pill'>
            {req.action.location.description}
          </Badge>
        </div>
        <div className={classes.divider} />
        <div className={classes.body}>
          <div>{req.comment}</div>
          {Boolean(req.dropDownListVal1) && (
            <div>
              <b>List 1: </b>
              {req.dropDownListVal1}
            </div>
          )}
          {Boolean(req.dropDownListVal2) && (
            <div>
              <b>List 2: </b>
              {req.dropDownListVal2}
            </div>
          )}
          {Boolean(req.dynamicInput) && (
            <div>
              <b>Input: </b>
              {req.dynamicInput}
            </div>
          )}
          {req.dynamicInputResult && Object.keys(req.dynamicInputResult) && (
            <div>
              <DynamicActionInputResult request={req} />
            </div>
          )}
          {Boolean(req.requestQty) && (
            <div>
              <b>Quantity: </b>
              {req.requestQty}
            </div>
          )}
          <div className={classes.history}>
            <RequestCardHistory title='Requested' user={req.requestorId} date={req.creationDate} />
            {ACCEPTED_HISTORY_STATUS.has(req.status) && req.acceptTime && req.acceptUserId && (
              <RequestCardHistory title='Accepted' user={req.acceptUserId} date={req.acceptTime} />
            )}
            {req.status === STATUSES.ON_HOLD && req.onHoldTime && req.onHoldUserId && (
              <RequestCardHistory
                title='Put on Hold'
                user={req.onHoldUserId}
                date={req.onHoldTime}
                holdReason={/** @type {{ onHoldReason?: string | null }} */ (req).onHoldReason ?? ''}
              />
            )}
            {req.status === STATUSES.COMPLETED && req.completionTime && req.completionUserId && (
              <RequestCardHistory title='Completed' user={req.completionUserId} date={req.completionTime} />
            )}
          </div>
        </div>
        <div className={classes.footer}>
          <RequestCardButtons request={req} />
        </div>
      </Card>
    ))}
  </div>
);
